import { buildStyles, CircularProgressbar } from "react-circular-progressbar";

import Typography from "@components/Typography";

import styles from "../AccountView.module.css";

const UsageConsumption = ({
  value,
  maxValue,
  showPercentage,
  label,
  detailedText,
}) => {
  const usage = value / maxValue;
  const pathColor =
    usage >= 0.9
      ? "var(--sentiment-negative)"
      : usage >= 0.75
        ? "var(--pink-600)"
        : "var(--blue-600)";

  return (
    <div>
      <div className={styles.valueContainer}>
        {maxValue ? (
          <CircularProgressbar
            maxValue={maxValue}
            styles={buildStyles({
              pathColor: pathColor,
              textColor: "var(--on-background)",
              trailColor: "var(--gray-300)",
              strokeLinecap: "butt",
              textSize: "16px",
            })}
            text={
              showPercentage
                ? `${(usage * 100).toFixed(0)}%`
                : `${value}/${maxValue}`
            }
            value={value}
          />
        ) : (
          <span className={styles.justValueNumber}>{value}</span>
        )}
      </div>
      <Typography align="center" margin="none" block>
        <strong>{label}</strong>
      </Typography>

      {detailedText && (
        <Typography align="center" className={styles.subtitle} block>
          {detailedText}
        </Typography>
      )}
    </div>
  );
};

export default UsageConsumption;
